import { Injectable, signal } from '@angular/core';
import {
  DEFAULT_LOCALE,
  type I18nSource,
  type RuntimeLocale,
  type TranslationDictionary,
} from './i18n.types';

@Injectable({ providedIn: 'root' })
export class I18nStore {
  private readonly localeSignal = signal<RuntimeLocale>(DEFAULT_LOCALE);
  private readonly sourceSignal = signal<I18nSource>('default');
  private readonly dictionariesSignal = signal<Partial<Record<RuntimeLocale, TranslationDictionary>>>(
    {}
  );
  private readonly loadingSignal = signal<boolean>(false);

  readonly locale = this.localeSignal.asReadonly();
  readonly source = this.sourceSignal.asReadonly();
  readonly dictionaries = this.dictionariesSignal.asReadonly();
  readonly loading = this.loadingSignal.asReadonly();

  setLocale(locale: RuntimeLocale, source: I18nSource): void {
    this.localeSignal.set(locale);
    this.sourceSignal.set(source);
  }

  setDictionary(locale: RuntimeLocale, dictionary: TranslationDictionary): void {
    this.dictionariesSignal.update((current) => ({
      ...current,
      [locale]: dictionary,
    }));
  }

  setLoading(loading: boolean): void {
    this.loadingSignal.set(loading);
  }
}
